import React from "react";

import PropTypes from "prop-types";

import RbFlexTableRow from "components/RbFlexTableRow";

import CarForm from "../CarForm";

function CarNewRow(props) {
  const { expanded, onCancel } = props;

  const [car, setCar] = React.useState({});

  const handleSave = React.useCallback(() => {
    setCar({});
  }, []);

  return (
    <RbFlexTableRow
      renderExpand={() => (
        <CarForm car={car} onCancel={onCancel} onSave={handleSave} />
      )}
      expanded={expanded}
      onlyExpand
    />
  );
}

CarNewRow.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default React.memo(CarNewRow);
